export default "__VITE_ASSET__CRiuVuq7__"